import {
  isAllFilterIds,
  normalizeFilterIds,
} from '../../data/executiveDashboardFilters'

export const EXECUTIVE_INDEPENDENT_BRAND_ID = 'independent'

export function getClientHotelBrandId(client) {
  const brandId = client?.brand?.id
  if (brandId == null || brandId === '') return EXECUTIVE_INDEPENDENT_BRAND_ID
  return String(brandId)
}

export function clientMatchesHotelBrandIds(client, hotelBrandIds) {
  const normalized = normalizeFilterIds(hotelBrandIds)
  if (isAllFilterIds(normalized)) return true
  return normalized.includes(getClientHotelBrandId(client))
}

export function filterClientsByHotelBrandIds(clients, hotelBrandIds) {
  const list = Array.isArray(clients) ? clients : []
  const normalized = normalizeFilterIds(hotelBrandIds)
  if (isAllFilterIds(normalized)) return list
  return list.filter((client) => clientMatchesHotelBrandIds(client, normalized))
}

export function hasIndependentClients(clients) {
  return (Array.isArray(clients) ? clients : []).some(
    (client) => client?.brand == null,
  )
}

export function buildExecutiveHotelBrandOptions(organizationBrands, clients) {
  const rows = Array.isArray(organizationBrands) ? organizationBrands : []
  const options = [
    { id: 'all', label: 'All brands' },
    ...rows.map((row) => ({
      id: String(row.id),
      label: row.brand || `Brand ${row.id}`,
    })),
  ]

  if (hasIndependentClients(clients)) {
    const alreadyIncluded = options.some(
      (option) => option.id === EXECUTIVE_INDEPENDENT_BRAND_ID,
    )
    if (!alreadyIncluded) {
      options.splice(1, 0, {
        id: EXECUTIVE_INDEPENDENT_BRAND_ID,
        label: 'Independent',
      })
    }
  }

  return options
}

/** Numeric brand ids for API query params (excludes Independent pseudo-brand). */
export function toApiBrandIds(hotelBrandIds) {
  const normalized = normalizeFilterIds(hotelBrandIds)
  if (isAllFilterIds(normalized)) return []
  return normalized.filter(
    (id) => id !== EXECUTIVE_INDEPENDENT_BRAND_ID && /^\d+$/.test(String(id)),
  )
}

export function resolveExecutiveReportScope(clients, filters = {}) {
  const propertyIds = normalizeFilterIds(filters.propertyIds)
  const hotelBrandIds = normalizeFilterIds(filters.hotelBrandIds)
  const clientList = Array.isArray(clients) ? clients : []

  if (!isAllFilterIds(propertyIds)) {
    return {
      clientIds: propertyIds,
      brandIds: [],
    }
  }

  if (isAllFilterIds(hotelBrandIds)) {
    return { clientIds: [], brandIds: [] }
  }

  const apiBrandIds = toApiBrandIds(hotelBrandIds)
  const includesIndependent = hotelBrandIds.includes(EXECUTIVE_INDEPENDENT_BRAND_ID)

  if (includesIndependent) {
    const scopedClients = filterClientsByHotelBrandIds(clientList, hotelBrandIds)
    return {
      clientIds: scopedClients.map((client) => String(client.id)),
      brandIds: [],
    }
  }

  return { clientIds: [], brandIds: apiBrandIds }
}
